/* Copyright 2016-2018 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dojo/dom-construct",
    "dojo/_base/lang",
    "dojo/on",
    "mw-form/TextField",
    "MW/uiframework/utils"
], function(declare, domConstruct, lang, on, TextField, utils){

    return declare(TextField, {
        baseClass: "mwWidget mwTextField mwSearchTextField",
        _listeners: [],

        postCreate: function(){
            this.inherited(arguments);
            this.clearLink = domConstruct.create("div",{
                "class": "clearTextContainerNode"
            }, this.domNode);

            this.toggleSearchBoxIcon();
            this.on("typing", lang.hitch(this, this.toggleSearchBoxIcon));

            if (utils.isCJKLocale()) {
                // g1957116: Qt doesn't support sending key events during IME input. This results in Clear link not
                // getting updated correctly when user types something or clears the input field completely. Hence, we
                // need to make use of "compositionupdate" event which gets fired when a new character is received
                // in the IME mode.
                this._listeners.push(utils.addEventListener(this.inputNode, "compositionupdate",
                    this._handleCompositionUpdate.bind(this)));
            }

            this.watch("value", lang.hitch(this, this.toggleSearchBoxIcon));
            this.own(on(this.clearLink, "click", lang.hitch(this, this._onClickClearButtonHandler)));
        },

        _handleCompositionUpdate: function (e) {
            // There might be some inconsistencies between the actual value and inputNode.value as it takes some
            // time for the value to get updated in the inputNode when in IME mode. Use e.data as recommended in the
            // mdn web docs since it has the correct value.
            var emptyInputValue = e.data !== "";
            this._updateclearLink(emptyInputValue);
        },

        toggleSearchBoxIcon: function () {
            var emptyInputValue = this.inputNode.value !== "";
            this._updateclearLink(emptyInputValue);
        },

        _updateclearLink: function (emptyInputValue) {
            if (emptyInputValue) {
                this.clearLink.classList.add("clearTextIconVisible");
                this.clearLink.setAttribute("tabindex", "0");
            } else {
                this.clearLink.classList.remove("clearTextIconVisible");
                this.clearLink.removeAttribute("tabindex");
            }
        },

        _onClickClearButtonHandler: function(){
            this.set("value", "");
            this._triggerTypingEvent("");
            this.toggleSearchBoxIcon();
            this.focusNode.focus(); // Focus the searchTextField when the clear button is clicked
        },

        destroy: function () {
            this._listeners.forEach(function (listener) {
                listener.remove();
            });

            this.inherited(arguments);
        }
    });
});